import { Skeleton } from "@/components/ui/skeleton";

interface Props {
  rows?: number;
  cols?: number;
  /** Show header row. */
  header?: boolean;
}

/**
 * LoadingTable — shimmer skeleton cho table view (audit logs, translations,
 * etc). Doc 31.
 */
export function LoadingTable({
  rows = 6,
  cols = 4,
  header = true,
}: Props): JSX.Element {
  return (
    <div className="rounded-md border bg-background overflow-hidden" aria-label="Loading">
      {header ? (
        <div className="border-b bg-muted/30 px-3 py-2 grid gap-3" style={{ gridTemplateColumns: `repeat(${cols}, 1fr)` }}>
          {Array.from({ length: cols }).map((_, i) => (
            <Skeleton key={`h-${i}`} className="h-3 w-20" />
          ))}
        </div>
      ) : null}
      <div className="divide-y">
        {Array.from({ length: rows }).map((_, i) => (
          <div
            key={`r-${i}`}
            className="px-3 py-3 grid gap-3 items-center"
            style={{ gridTemplateColumns: `repeat(${cols}, 1fr)` }}
          >
            {Array.from({ length: cols }).map((_, j) => (
              <Skeleton
                key={`c-${i}-${j}`}
                className="h-4"
                style={{ width: `${50 + ((i + j) % 4) * 12}%` }}
              />
            ))}
          </div>
        ))}
      </div>
    </div>
  );
}
